import { render, staticRenderFns } from "./IntroStore.vue?vue&type=template&id=2103bcc0"
import script from "./IntroStore.vue?vue&type=script&lang=js"
export * from "./IntroStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports